/* ── BHP THEME JS ── */
document.addEventListener('DOMContentLoaded', () => {

  /* ── WISHLIST ── */
  const WISH_KEY = 'bhp_wishlist';
  const rawWl = JSON.parse(localStorage.getItem(WISH_KEY) || 'null');
  const wishlist = (rawWl && !Array.isArray(rawWl)) ? rawWl : {};
  if (!rawWl || Array.isArray(rawWl)) localStorage.setItem(WISH_KEY, '{}');
  function saveWishlist() { localStorage.setItem(WISH_KEY, JSON.stringify(wishlist)); }

  function initWishlistBtns(root) {
    (root || document).querySelectorAll('.wishlist-btn').forEach(btn => {
      if (btn._wlBound) return;
      btn._wlBound = true;
      const id = String(btn.dataset.productId);
      if (id && wishlist[id] !== undefined) btn.classList.add('is-liked');
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        const handle = btn.dataset.productHandle || '';
        if (wishlist[id] !== undefined) { delete wishlist[id]; } else { wishlist[id] = handle; }
        btn.classList.toggle('is-liked');
        saveWishlist();
      });
    });
  }
  initWishlistBtns();

  /* ── QUICK ADD TO BAG ── */
  function initQuickAddBtns(root) {
    (root || document).querySelectorAll('.quick-add-btn').forEach(btn => {
      if (btn._qaBound) return;
      btn._qaBound = true;
      btn.addEventListener('click', async e => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn._qaLoading) return;
        btn._qaLoading = true;
        const original = btn.textContent;
        btn.textContent = '•••';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          });
          btn.textContent = res.ok ? '✓ Added' : 'Sold Out';
          if (res.ok) updateCartCount();
        } catch {
          btn.textContent = original;
          btn._qaLoading = false;
          return;
        }
        setTimeout(() => { btn.textContent = original; btn._qaLoading = false; }, 1800);
      });
    });
  }
  initQuickAddBtns();

  /* ── MOBILE MENU ── */
  const menuDrawer  = document.getElementById('menu-drawer');
  const menuOverlay = document.querySelector('.js-menu-overlay');
  const openBtns    = document.querySelectorAll('.js-menu-open');
  const closeBtns   = document.querySelectorAll('.js-menu-close');

  function openMenu() {
    menuDrawer?.classList.add('open');
    menuOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menuDrawer?.classList.remove('open');
    menuOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(b => b.addEventListener('click', openMenu));
  closeBtns.forEach(b => b.addEventListener('click', closeMenu));
  menuOverlay?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  /* ── PRODUCT GALLERY ── */
  const track = document.getElementById('gallery-track');
  const dots  = document.querySelectorAll('.gallery-dot');

  if (track && dots.length) {
    function updateDots() {
      const index = Math.round(track.scrollLeft / track.offsetWidth);
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
    }
    track.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* ── CATEGORY PILLS (non-browse) ── */
  document.querySelectorAll('.pills-wrap:not(#browse-pills)').forEach(group => {
    group.querySelectorAll('.pill').forEach(pill => {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

  /* ── SIZE SELECTOR (PDP) ── */
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.size-row')?.querySelectorAll('.size-btn')
          .forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      if (this.dataset.variantId) {
        document.querySelectorAll('.atb-btn').forEach(atb => {
          atb.dataset.variantId = this.dataset.variantId;
        });
      }
    });
  });

  /* ── ADD TO BAG (AJAX cart) ── */
  const atbBtns = document.querySelectorAll('.atb-btn');
  if (atbBtns.length) {
    let atbBusy = false;
    function setAllAtb(text, disabled) {
      atbBtns.forEach(b => {
        if (text !== undefined) b.textContent = text;
        if (disabled !== undefined) b.disabled = disabled;
      });
    }
    atbBtns.forEach(atbBtn => {
      atbBtn.addEventListener('click', async function () {
        if (atbBusy) return;
        const variantId = this.dataset.variantId;
        if (!variantId || this.disabled) return;
        const originalLabel = this.dataset.label || this.textContent;
        atbBusy = true;
        setAllAtb('Adding…', true);
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (res.ok) {
            setAllAtb('Added ✓', true);
            updateCartCount();
            setTimeout(() => { setAllAtb(originalLabel, false); atbBusy = false; }, 2200);
          } else {
            setAllAtb('Sold Out', true);
            setTimeout(() => { setAllAtb(originalLabel, false); atbBusy = false; }, 2200);
          }
        } catch {
          setAllAtb('Try Again', false);
          atbBusy = false;
        }
      });
    });
  }

  /* ── CART COUNT ── */
  async function updateCartCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch {}
  }
  updateCartCount();

  /* ── BROWSE SECTION TABS ── */
  const browsePills   = document.getElementById('browse-pills');
  const browseGrid    = document.getElementById('browse-grid');
  const browseViewAll = document.getElementById('browse-viewall');

  if (browsePills && browseGrid) {
    let browseLoading = false;

    function renderBrowseCard(p) {
      const imgSrc      = p.images && p.images[0] ? p.images[0].src : '';
      const priceNum    = parseFloat(p.variants[0].price);
      const price       = '$' + priceNum.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      const compareAtNum = p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : 0;
      const isSale      = compareAtNum > priceNum;
      const brand       = (p.vendor && p.vendor !== 'basic human pieces') ? p.vendor : '';
      const avail       = p.variants.some(v => v.available);
      const liked       = wishlist[String(p.id)] !== undefined;
      const firstAvailVariant = p.variants.find(v => v.available) || p.variants[0];

      const tagList    = Array.isArray(p.tags) ? p.tags.map(t => t.toLowerCase()) : (p.tags || '').split(', ').map(t => t.toLowerCase().trim()).filter(Boolean);
      const isRare     = tagList.includes('rare');
      const isArchive  = tagList.includes('archive');
      const isDesigner = tagList.includes('designer');
      const ageMs      = Date.now() - new Date(p.created_at).getTime();
      const isNew      = ageMs < 14 * 24 * 60 * 60 * 1000;

      let badges = '';
      if (isSale)                              badges += '<span class="badge badge-sale">Sale</span>';
      if (isRare)                              badges += '<span class="badge badge-rare">Rare Find</span>';
      if (isArchive)                           badges += '<span class="badge badge-archive">Archive</span>';
      if (isDesigner && !isRare && !isArchive) badges += '<span class="badge badge-designer">Designer</span>';
      if (isNew && !isRare && !isArchive)      badges += '<span class="badge badge-new">Just In</span>';
      const badgeWrap = badges ? '<div class="badge-wrap">' + badges + '</div>' : '';

      const compareHtml = isSale
        ? '<div class="product-price-compare">$' + compareAtNum.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '</div>'
        : '';

      const imgTag = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:var(--s3);"></div>';

      return '<a class="product-card" href="/products/' + p.handle + '" data-avail="' + avail + '">'
        + '<div class="product-card-image">'
        + badgeWrap
        + imgTag
        + (!avail ? '<div class="sold-overlay"><div class="sold-label">Sold</div></div>' : '')
        + '<button class="wishlist-btn' + (liked ? ' is-liked' : '') + '" data-product-id="' + p.id + '" data-product-handle="' + p.handle + '" aria-label="Save">'
        + '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + '</button>'
        + '</div>'
        + '<div class="product-info">'
        + (brand ? '<div class="product-brand">' + brand + '</div>' : '')
        + '<div class="product-name">' + p.title + '</div>'
        + '<div class="product-price-row">'
        + '<div>'
        + '<div class="product-price' + (avail ? (isSale ? ' sale' : '') : ' sold-out') + '">' + price + '</div>'
        + compareHtml
        + '</div>'
        + (avail ? '<span class="quick-add-btn" data-variant-id="' + firstAvailVariant.id + '">+ Bag</span>' : '')
        + '</div></div></a>';
    }

    async function loadBrowse(handle) {
      if (browseLoading) return;
      browseLoading = true;
      browseGrid.style.opacity = '0.35';
      try {
        const limit = window.innerWidth >= 768 ? 9 : 8;
        const url = '/collections/' + handle + '/products.json?limit=' + limit;
        const { products } = await fetch(url).then(r => r.json());
        const sorted = [...products].sort((a, b) => {
          const aA = a.variants.some(v => v.available);
          const bA = b.variants.some(v => v.available);
          return aA === bA ? 0 : aA ? -1 : 1;
        });
        browseGrid.innerHTML = sorted.map(renderBrowseCard).join('');
        browseGrid.style.opacity = '1';
        if (browseViewAll) browseViewAll.href = handle === 'all' ? '/collections/all' : '/collections/' + handle;
        initWishlistBtns(browseGrid);
        initQuickAddBtns(browseGrid);
      } catch {
        browseGrid.style.opacity = '1';
      }
      browseLoading = false;
    }

    browsePills.querySelectorAll('.pill').forEach(pill => {
      pill.addEventListener('click', function () {
        browsePills.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
        this.classList.add('active');
        loadBrowse(this.dataset.collection);
      });
    });
  }

  /* ── SORT SOLD TO BOTTOM (collection pages) ── */
  const collGrid = document.getElementById('collection-grid');
  if (collGrid) {
    const soldCards = [...collGrid.querySelectorAll('.product-card[data-avail="false"]')];
    soldCards.forEach(c => collGrid.appendChild(c));
  }

  /* ── SORT SOLD TO BOTTOM (browse grid) ── */
  if (browseGrid) {
    [...browseGrid.querySelectorAll('.product-card[data-avail="false"]')]
      .forEach(c => browseGrid.appendChild(c));
  }

  /* ── COLLECTION FILTER DRAWER ── */
  const filterToggle  = document.getElementById('filter-toggle');
  const filterClose   = document.getElementById('filter-close');
  const filterDrawer  = document.getElementById('filter-drawer');
  const filterOverlay = document.getElementById('filter-overlay');
  const filterApply   = document.getElementById('filter-apply');
  const filterClear   = document.getElementById('filter-clear');

  if (filterToggle && filterDrawer) {
    let activeType      = 'all';
    let activePrice     = 'all';
    let activeCondition = 'all';
    let activeSize      = 'all';

    function openFilter() {
      filterDrawer.classList.add('open');
      filterDrawer.setAttribute('aria-hidden', 'false');
      filterOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeFilter() {
      filterDrawer.classList.remove('open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      filterOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    filterToggle.addEventListener('click', openFilter);
    filterClose?.addEventListener('click', closeFilter);
    filterOverlay?.addEventListener('click', closeFilter);

    filterDrawer.querySelectorAll('.filter-chips').forEach(group => {
      group.querySelectorAll('.filter-chip').forEach(chip => {
        chip.addEventListener('click', function () {
          group.querySelectorAll('.filter-chip').forEach(c => c.classList.remove('active'));
          this.classList.add('active');
          if (group.dataset.filter === 'type')      activeType      = this.dataset.value;
          if (group.dataset.filter === 'price')     activePrice     = this.dataset.value;
          if (group.dataset.filter === 'condition') activeCondition = this.dataset.value;
          if (group.dataset.filter === 'size')      activeSize      = this.dataset.value;
        });
      });
    });

    function applyFilter() {
      const cards = collGrid ? [...collGrid.querySelectorAll('.product-card')] : [];
      let visible = 0;
      cards.forEach(card => {
        const matchType      = activeType === 'all'      || (card.dataset.type || '') === activeType;
        const matchPrice     = activePrice === 'all'     || (card.dataset.price || '') === activePrice;
        const matchCondition = activeCondition === 'all' || (card.dataset.condition || '') === activeCondition;
        const matchSize      = activeSize === 'all'      || (card.dataset.size || '') === activeSize;
        const show = matchType && matchPrice && matchCondition && matchSize;
        card.classList.toggle('filter-hidden', !show);
        if (show) visible++;
      });
      const countEl = document.getElementById('col-count');
      const hasActive = activeType !== 'all' || activePrice !== 'all' || activeCondition !== 'all' || activeSize !== 'all';
      if (countEl) countEl.textContent = visible + (visible === 1 ? ' piece' : ' pieces') + (hasActive ? ' — filtered' : ' · All 1 of 1');
      filterToggle.classList.toggle('active', hasActive);
      closeFilter();
    }

    function clearFilter() {
      activeType      = 'all';
      activePrice     = 'all';
      activeCondition = 'all';
      activeSize      = 'all';
      filterDrawer.querySelectorAll('.filter-chip').forEach(c => {
        c.classList.toggle('active', c.dataset.value === 'all');
      });
      applyFilter();
    }

    filterApply?.addEventListener('click', applyFilter);
    filterClear?.addEventListener('click', clearFilter);
  }

});
